import { Select } from "antd";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

/**
 * A responsive select input component optimized for iPhone/mobile
 */
const SelectInput = ({
  label,
  options = [],
  placeholder,
  name,
  onChange,
  customError,
  required,
}) => {
  const { errors, touched } = useFormikContext();
  const { t } = useTranslation("global");

  return (
    <Field name={name}>
      {({ field }) => (
        <div className="flex-1 flex flex-col gap-2">
          <label htmlFor={name} className="text-sm font-medium text-gray-700">
            {label} {required && "*"}
          </label>

          <Select
            {...field}
            className="w-full"
            placeholder={placeholder}
            value={field.value || undefined}
            onChange={(value) => {
              field.onChange({ target: { name, value } });
              if (onChange) onChange(value);
            }}
            onBlur={field.onBlur}
            virtual={false}
            dropdownRender={DropDownRender}
            dropdownStyle={{ maxHeight: 250, overflowY: "auto" }}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>

          {errors[name] && touched[name] && (
            <p className="text-text_warning text-sm mt-1">{t(errors[name])}</p>
          )}
          {errors[name] && customError && (
            <span style={{ color: "#ff4d4f", fontSize: "small" }}>
              {t(errors[name])}
            </span>
          )}
        </div>
      )}
    </Field>
  );
};

// Dropdown scrollable wrapper
const DropDownRender = (menu) => (
  <div className="max-h-[250px] overflow-auto touch-manipulation">{menu}</div>
);

export default SelectInput;
